import type { ComponentProps, ReactNode } from "react";
import { Skeleton } from "@papier/ui/components/ui/skeleton";
import { cn } from "@papier/ui/lib/utils";

export function DestructiveActionCard({
  title,
  description,
  action,
  isPending,
  className,
  children,
  ...props
}: Omit<ComponentProps<"div">, "title"> & {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  isPending?: boolean;
}) {
  return (
    <div
      {...props}
      data-slot="destructive-action-card"
      className={cn(
        "flex flex-wrap items-center justify-between gap-5 rounded-xl border border-destructive/20 bg-background p-5 sm:p-6",
        className,
      )}
      aria-busy={isPending || undefined}
    >
      <div className="min-w-0 flex-1 basis-56">
        {isPending ? (
          <div className="space-y-3">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-3 w-full max-w-sm" />
          </div>
        ) : (
          <>
            <h3 className="text-sm font-medium">{title}</h3>
            {description && (
              <div className="mt-2 text-xs leading-relaxed text-muted-foreground">
                {description}
              </div>
            )}
            {children}
          </>
        )}
      </div>
      {action && (
        <div className="shrink-0">{isPending ? <Skeleton className="h-9 w-36" /> : action}</div>
      )}
    </div>
  );
}
